"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userStatusSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.userStatusSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        accountStatusCode: {
            type: 'number',
            enum: Object.values(constants_1.AccountStatus),
            errorMessage: 'Should equate to a valid AccountStatus Enum value',
        },
        adAccountStatusCode: {
            type: 'number',
            enum: Object.values(constants_1.AccountStatus),
            errorMessage: 'Should equate to a valid AccountStatus Enum value',
        },
        adSynchronizationStatusCode: {
            type: 'number',
            enum: Object.values(constants_1.SynchronizationStatus),
            errorMessage: 'Should equate to a valid SynchronizationStatus Enum value',
        },
        contactSynchronizationStatusCode: {
            type: 'number',
            enum: Object.values(constants_1.SynchronizationStatus),
            errorMessage: 'Should equate to a valid SynchronizationStatus Enum value',
        },
    },
};
